export const clientSideMessages = {
  en: {
    contactFormAgreementText:
      'I agree to the privacy policy of Immigrant Invest. Detailed information on how we process your personal data can be found <link>here</link>',
    linkCopied: 'link copied',
    clickToCopyLink: 'Click to copy link',
    fieldIsRequired: 'This field is required',
    contactFormEmailError: 'Incorrect email',
    characters: 'Characters',
    charactersLeft: 'Characters left',
    name: 'Name',
    emailAgreement: 'I agree to receive emails from Immigrant Invest',
    email: 'Email',
    contactFormNameError: 'Required field',
    contactFormTextError: 'The field must contain at least 10 characters',
    pleaseSelect: 'Please select',
    thanksForSubscribing: 'Thanks for subscribing',
    theLastStepPleaseConfirmYourEmail:
      'The last step: please confirm your email',
    subscribe: 'Subscribe',
    showMore: 'Show more',
    showLess: 'Show less',
    allCountries: 'All countries',
    nextPage: 'Next',
    prevPage: 'Previous',
    searchAnyWord: 'Search by a topic, category, country or any word',
    resources: 'Resources',
    all: 'All',
    contactFormSuccess: 'Thanks for your request. We will contact you shortly.',
    search: 'Search',
  },
  ru: {
    contactFormAgreementText:
      'Я согласен с политикой конфиденциальности Immigrant Invest. Подробную информацию о том, как мы обрабатываем ваши персональные данные, можно найти <link>здесь</link>',
    linkCopied: 'Скопирована',
    clickToCopyLink: 'Копировать ссылку',
    fieldIsRequired: 'Поле обязательно для заполнения',
    contactFormEmailError: 'Некорректный email',
    characters: 'Символов',
    charactersLeft: 'Символов осталось',
    name: 'Имя',
    emailAgreement:
      'Я согласен получать электронные письма от Immigrant Invest',
    email: 'Эл. почта',
    contactFormNameError: 'Обязательное поле',
    contactFormTextError: 'Поле должно содержать не менее 10 символов',
    pleaseSelect: 'Пожалуйста, выберите',
    thanksForSubscribing: 'Спасибо за подписку',
    theLastStepPleaseConfirmYourEmail: 'Осталось лишь подвердить email',
    subscribe: 'Подписаться',
    showMore: 'Показать ещё',
    showLess: 'Показать меньше',
    allCountries: 'Все страны',
    nextPage: 'Дальше',
    prevPage: 'Предыдущая',
    searchAnyWord: 'Поиск по теме, рубрике, стране или любому слову',
    resources: 'Ресурсы',
    all: 'Все',
    contactFormSuccess:
      'Спасибо за ваш запрос. Мы свяжемся с вами в ближайшее время',
    search: 'Выбрать',
  },
  de: {
    contactFormAgreementText:
      'Ich stimme den Datenschutzbestimmungen von Immigrant Invest zu. Detaillierte Informationen darüber, wie wir Ihre personenbezogenen Daten verarbeiten, finden Sie <link>hier</link>',
    linkCopied: 'link kopiert',
    clickToCopyLink: 'Link kopieren',
    fieldIsRequired: 'aus Dieses Feld ist erforderlich',
    contactFormEmailError: 'Falsche E-Mail',
    characters: 'Charaktere',
    charactersLeft: 'Verbleibende Zeichen',
    name: 'Name',
    emailAgreement:
      'Ich bin damit einverstanden, E-Mails von Immigrant Invest zu erhalten',
    email: 'E-Mail',
    contactFormNameError: 'Erforderliches Feld',
    contactFormTextError: 'Das Feld muss mindestens 10 Zeichen enthalten',
    pleaseSelect: 'Bitte wählen Sie',
    thanksForSubscribing: 'Vielen Dank für Ihr Abonnement',
    theLastStepPleaseConfirmYourEmail:
      'Der letzte Schritt: Bitte bestätigen Sie Ihre E-Mail',
    subscribe: 'Abonnieren',
    seeMore: 'Mehr anzeigen',
    showMore: 'Mehr anzeigen',
    showLess: 'Zeige weniger',
    allCountries: 'Alle Länder',
    nextPage: 'Weiter',
    prevPage: 'Zurück',
    searchAnyWord:
      'Suchen Sie nach einem Thema, einer Kategorie, einem Land oder einem beliebigen Wort',
    resources: 'Ressourcen',
    all: 'All',
    contactFormSuccess:
      'Bedankt voor je aanvraag. Wij nemen binnenkort contact met u op.',
    search: 'Suchen',
  },
  tr: {
    contactFormAgreementText:
      'Immigrant Invest gizlilik politikalarını kabul ediyorum. Kişisel verilerinizi nasıl işlediğimizle ilgili ayrıntılı bilgiye <link>buradan</link> ulaşabilirsiniz.',
    linkCopied: 'Bağlantı kopyalandı',
    clickToCopyLink: 'Kopyalamak için tıklayın',
    fieldIsRequired: 'Bu alan zorunludur',
    contactFormEmailError: 'Geçersiz e-posta',
    characters: 'Karakterler',
    charactersLeft: 'Kalan karakterler',
    name: 'Ad',
    emailAgreement: "Immigrant Invest'ten e-posta almayı kabul ediyorum",
    email: 'E-posta',
    contactFormNameError: 'Zorunlu alan',
    contactFormTextError: 'Alan en az 10 karakter içermelidir',
    pleaseSelect: 'Lütfen seçin',
    thanksForSubscribing: 'Abone olduğunuz için teşekkür ederiz',
    theLastStepPleaseConfirmYourEmail:
      'Son adım: lütfen e-posta adresinizi onaylayın',
    subscribe: 'Abone Ol',
    showMore: 'Daha fazla göster',
    showLess: 'Daha az göster',
    allCountries: 'Tüm ülkeler',
    nextPage: 'İleri',
    prevPage: 'Önceki',
    searchAnyWord: 'Konu, kategori, ülke veya herhangi bir kelime ile ara',
    resources: 'Kaynaklar',
    all: 'Tüm',
    contactFormSuccess:
      'Başvurunuz için teşekkür ederiz. Yakında sizinle iletişime geçeceğiz.',
    search: 'Ara',
  },
  es: {
    contactFormAgreementText:
      'Acepto la política de privacidad de Immigrant Invest. Puede encontrar información detallada sobre cómo procesamos sus datos personales <link>aquí</link>',
    linkCopied: 'enlace copiado',
    clickToCopyLink: 'Haga clic para copiar el enlace',
    fieldIsRequired: 'Este campo es obligatorio',
    contactFormEmailError: 'Correo electrónico incorrecto',
    characters: 'Caracteres',
    charactersLeft: 'Caracteres restantes',
    name: 'Nombre',
    emailAgreement: 'Acepto recibir correos electrónicos de Immigrant Invest',
    email: 'Correo electrónico',
    contactFormNameError: 'Campo obligatorio',
    contactFormTextError: 'El campo debe contener al menos 10 caracteres',
    pleaseSelect: 'Por favor seleccione',
    thanksForSubscribing: 'Gracias por suscribirse',
    theLastStepPleaseConfirmYourEmail:
      'El último paso: por favor confirme su correo electrónico',
    subscribe: 'Suscribirse',
    showMore: 'Mostrar más',
    showLess: 'Mostrar menos',
    allCountries: 'Todos los países',
    nextPage: 'Siguiente',
    prevPage: 'Anterior',
    searchAnyWord: 'Buscar por tema, categoría, país o cualquier palabra',
    resources: 'Recursos',
    all: 'Todos',
    contactFormSuccess:
      'Gracias por su solicitud. Nos pondremos en contacto con usted en breve.',
    search: 'Buscar',
  },
};
